import classnames from 'classnames';

import './BaseBox.scss';

export const BaseBox = (props) => {
  const { className, lifted, children, borderless, box } = props;

  const classes = classnames('base-box', className, {
    'base-box--lifted': lifted,
    'base-box--borderless': borderless,
    'base-box--box': box,
  });

  return (
    <div className={classes} data-testid={props['data-testid']}>
      {children}
    </div>
  );
};

export default BaseBox;
